import { CSS } from '@project44/manifest-ds';

import { Skeleton } from './Skeleton';

interface Props {
  css?: CSS;
}

export const SkeletonText: React.FC<Props> = ({ css }) => (
  <Skeleton
    css={{
      display: 'inline-block',
      maxW: '100%',
      w: '100px',
      ...css,
    }}
    asSpan
  />
);
